import type { ProfileResponse } from "@/schemas";
import { ProfileResponseSchema } from "@/schemas";

import { apiRequestFormData } from "./apiUtils";

export async function uploadAvatar(file: File): Promise<ProfileResponse> {
  const formData = new FormData();
  formData.append("avatar", file);
  const data = await apiRequestFormData<unknown>(
    `user/profile/avatar`,
    formData,
  );
  return ProfileResponseSchema.parse(data);
}

export async function uploadResume(file: File): Promise<ProfileResponse> {
  const formData = new FormData();
  formData.append("resume", file);
  const data = await apiRequestFormData<unknown>(
    `user/profile/resume`,
    formData,
  );
  return ProfileResponseSchema.parse(data);
}

export async function uploadTaxDocuments(file: File): Promise<ProfileResponse> {
  const formData = new FormData();
  formData.append("tax_document", file);
  const data = await apiRequestFormData<unknown>(
    `user/profile/tax-document`,
    formData,
  );
  return ProfileResponseSchema.parse(data);
}
